import React from "react"

import Header from "./header"
import Footer from "./footer"

interface Props {
  headerTitle: string
  headerSubtitle: string
  headerActionName?: string
  headerAction?(): any
  children: React.ReactNode
}

const Layout: React.FC<Props> = ({
  children,
  headerTitle,
  headerSubtitle,
  headerActionName,
  headerAction,
}) => {
  return (
    <div className="flex flex-col min-h-screen font-sans text-gray-900">
      <Header
        title={headerTitle}
        subtitle={headerSubtitle}
        actionName={headerActionName}
        action={headerAction}
      />
      <main className="flex-1 w-full max-w-6xl px-4 py-8 mx-auto md:px-2 md:py-12">
        {children}
      </main>
      <Footer />
    </div>
  )
}

export default Layout
